const ToastService = {

    // Este metodo lo que hace es configurar como "plugin global" a las instancias 
    // de vue que se esten utilizando.
    install(Vue, options) {

        this.store = options.store;

        const toastService = {
            show: (message, options) => {
                this.store.toastService.message = message;
                this.store.toastService.active = true;
                this.store.toastService.color = options.color || "";
            },
            success: (message) => {
                toastService.show(message, { color: "success" });
            },
            error: (message) => {
                toastService.show(message, { color: "error" });

            },
            warning: (message) => {
                toastService.show(message, { color: "warning" });
            },
            info: (message) => {
                toastService.show(message, { color: "info" });
            },


        };

        Vue.prototype.$toast = toastService;

    }
};

export default ToastService;